import React from 'react';
import { Body2 } from '../typography';
import { Icon } from '../icon';
import { Button } from '../button';
import { ListItemContent } from '../list-item-content';
import { ListItemIcon } from '../list-item-icon';
import { Modal } from '../modal';
import { StyledModalBody, ModalList, ModalListItem, Email } from './styled';
export const ContactModal = ({ isOpen, onClose, text = 'Please contact us with any questions or feedback.', phone = '000-000-0000', email }) => {
    return (React.createElement(Modal, { title: "Contact Us", isOpen: isOpen, contentAs: StyledModalBody, actions: React.createElement(Button, { text: "Ok", color: "primary", onClick: onClose }), onClose: onClose, onBackgroundClick: onClose },
        React.createElement(Body2, { "$shade": "mediumEmphasis" }, text),
        React.createElement(ModalList, null,
            Boolean(phone) && (React.createElement(ModalListItem, { divider: false },
                React.createElement(ListItemIcon, null,
                    React.createElement(Icon, { name: "phone" })),
                React.createElement(ListItemContent, null,
                    React.createElement(Body2, null, phone)))),
            React.createElement(ModalListItem, null,
                React.createElement(ListItemIcon, null,
                    React.createElement(Icon, { name: "mail_outline" })),
                React.createElement(ListItemContent, null,
                    React.createElement(Email, { href: `mailto:${email}` },
                        React.createElement(Body2, null, email)))))));
};
